module.exports = __webpack_public_path__ + "img/carpark_pay_icon.8269f0f2.png";